"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformSavedStateApi = exports.SdPlatformSavedStateGetEmbedFields = exports.SdPlatformSavedStateQueryEmbeddableFields = void 0;
const ResourcesApi_1 = require("./commons/ResourcesApi");
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
var SdPlatformSavedStateQueryEmbeddableFields;
(function (SdPlatformSavedStateQueryEmbeddableFields) {
    SdPlatformSavedStateQueryEmbeddableFields["Model"] = "model";
    SdPlatformSavedStateQueryEmbeddableFields["Owner"] = "owner";
    SdPlatformSavedStateQueryEmbeddableFields["Image"] = "image";
})(SdPlatformSavedStateQueryEmbeddableFields = exports.SdPlatformSavedStateQueryEmbeddableFields || (exports.SdPlatformSavedStateQueryEmbeddableFields = {}));
;
var SdPlatformSavedStateGetEmbedFields;
(function (SdPlatformSavedStateGetEmbedFields) {
    SdPlatformSavedStateGetEmbedFields["Model"] = "model";
    SdPlatformSavedStateGetEmbedFields["Owner"] = "owner";
})(SdPlatformSavedStateGetEmbedFields = exports.SdPlatformSavedStateGetEmbedFields || (exports.SdPlatformSavedStateGetEmbedFields = {}));
/**
 * Operations for saved states.
 */
class SdPlatformSavedStateApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "saved_states";
    }
    /**
      * Gets a saved state by id.
      * @param id - saved state id.
      * @param embed the array of {@link SdPlatformSavedStateGetEmbedFields} embeddable fields.
      * @returns - the {@link SdPlatformGetResponse} with {@see SdPlatformResponseSavedStatePublic} or one of it's derived classes as response.
      */
    get(id, embed) {
        return super.__get(SdPlatformRequestId_1.RequestId.SavedStateGet, id, embed);
    }
    /**
     * Create a new saved state.
     * @param body {@link SdPlatformRequestSavedStateCreate} create saved state body.
     * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponseSavedStateOwner} or one of it's derived classes as data.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.SavedStateCreate, body);
    }
    /**
     * Patch a saved state.
     * @param id
     * @param body {@link SdPlatformRequestSavedStatePatch} saved state patch body.
     * @returns the {@link SdPlatformPatchResponse} with {@link SdPlatformResponseSavedStateOwner} or one of it's derived classes as result.
     */
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.SavedStatePatch, id, body);
    }
    /**
     * Delete a saved state.
     * @param id - the id of a saved state.
     * @returns the {@link SdPlatformDeleteResponse} response.
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.SavedStateDelete, id);
    }
    /**
     * Query saved states.
     * @param params {@link SdPlatformSavedStateApiQueryParameters} query parameters.
     * @returns the {@link SdPlatformQueryResponse} response with {@link SdPlatformResponseSavedStatePublic} or one of it's derived classes as response.
     */
    query(params) {
        return super.__query(SdPlatformRequestId_1.RequestId.SavedStateQuery, params);
    }
}
exports.SdPlatformSavedStateApi = SdPlatformSavedStateApi;
//# sourceMappingURL=SdPlatformSavedStateApi.js.map